import { CommonModule } from '@angular/common';
import { Component, OnInit, ElementRef, ViewChild, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { IPSAuthenticationService, IPSTenantKeyService } from '@ips/common-angular';
import { TenantService } from '../../tenant.service';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { SharedService } from '../../services/shared.service';
import { Popover } from 'primeng/popover';
import { PopoverModule } from 'primeng/popover';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { VocabHelperService } from '../../services/vocab-helper/vocab-helper.service';


@Component({
  selector: 'app-header',
  imports: [CommonModule, InputGroupModule, InputGroupAddonModule, ButtonModule,PopoverModule, InputTextModule ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChildren('dropdownItem') dropdownItems!: QueryList<ElementRef>;
  @ViewChild('searchInput') searchInput!: ElementRef;
  @ViewChild('op') op!: Popover;
  @ViewChild('placeOrderBtn') placeOrderBtn!: ElementRef;
  focusedDropdownIndex = 0;
  availableTenants?: string[] = [];
  selectedTenant?: string | null;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  avatarUrl?: string;
  accountname?: string;
  organizationVocabData: any = [];
  loggedInUserData: any;
  breadcrumbPath: MenuItem[] = [];
  subscriptions: Subscription = new Subscription();
  internalUser: boolean = false;
  profileDropdownOpen = false;

  constructor(
    private readonly router: Router,
    private readonly authz: IPSAuthenticationService,
    private readonly tenantKeyService: IPSTenantKeyService,
    private readonly tenantService: TenantService,
    private readonly vocabHelperService: VocabHelperService,
    private readonly sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.authz.currentUser.subscribe((user) => {
      this.tenantKeyService.getTenantKey().subscribe((selectedTenant) => {
        this.selectedTenant = selectedTenant;
      });
      this.tenantService.getAvailableTenants().subscribe((tenants) => {
        this.availableTenants = tenants || [];
        this.availableTenants.length === 1 && !this.selectedTenant ? this.tenantKeyService.setTenantKey(this.availableTenants[0].toUpperCase()) : '';
      });
      this.loggedInUserData = user;
      let organizationValue = this.loggedInUserData?.definition?.attributes?.find((item: any) => item?.key === 'organization' && item?.tenantKey?.toLowerCase() === this.selectedTenant?.toLowerCase());
      if (organizationValue?.value) {
        this.internalUser = false;
        this.fetchUserOrganizationVocab(organizationValue?.value);
      } else
          this.internalUser = true;
      this.firstName = user.firstName;
      this.lastName = user.lastName;
      this.displayName = user.definition?.displayName;
      this.avatarUrl = user.avatarURL;
    });

    this.subscribeBreadcrumbChange();
  }

  toggleNav() {
    const sidenav = document.getElementById('sidenav')!;
    if (sidenav.style.width === '128px') {
      sidenav.style.width = '0';
    } else {
      sidenav.style.width = '128px';
    }
  }
  
  toggleProfileDropdown(event: any) {
    this.op.toggle(event);
    this.profileDropdownOpen = !this.profileDropdownOpen;
    setTimeout(() => {
    const items = this.dropdownItems.toArray();
    if (items[0]) {
      this.currentDropdownIndex = 0;
      items[0].nativeElement.focus();
    }
  }, 0);
  }

  loadOrderInfoComponent(){
    this.router.navigate(['/home/place-order']);
  }

  currentDropdownIndex = 0;

  onDropdownItemKeyDown(event: KeyboardEvent, index: number) {
  const items = this.dropdownItems.toArray();

  if (event.key === 'ArrowDown') {
    event.preventDefault();
    this.currentDropdownIndex = (index + 1) % items.length;
    items[this.currentDropdownIndex].nativeElement.focus();
  }

  else if (event.key === 'ArrowUp') {
    event.preventDefault();
    this.currentDropdownIndex = (index - 1 + items.length) % items.length;
    items[this.currentDropdownIndex].nativeElement.focus();
  }

  else if (event.key === 'Tab' || event.key === 'Escape') {
    this.profileDropdownOpen = false;
    this.op.hide?.();
    setTimeout(() => this.placeOrderBtn?.nativeElement?.focus(), 0);
    return;
  }

}

  changeTenant(tenant: string): void {
    this.op.hide();
    this.tenantKeyService.setTenantKey(tenant);
    let organizationValue = this.loggedInUserData?.definition?.attributes?.find((item: any) => item?.key === 'organization' && item?.tenantKey?.toLowerCase() === this.selectedTenant?.toLowerCase());
    
    if (organizationValue?.value) { 
      this.setAccountNameDescription(organizationValue?.value);
    }
    const currentPath = this.router.url;
    this.sharedService.setOrderSearchTerm(null);
    this.resetOrderGridParamsStoredInService();
    if (currentPath.includes('/home/landing-page')) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/home/landing-page']);
    }
    if (this.searchInput) {
      this.searchInput.nativeElement.value = '';
    }

  }

  logout() {
    this.authz.logout();
  }

  fetchUserOrganizationVocab(organizationValue: any){
    this.vocabHelperService.getVocabData(['UserOrganization']).subscribe({
      next: (data) => {
        if (data) {
          this.organizationVocabData = data?.find(d => d.vocabularyName === 'UserOrganization');
          if (this.organizationVocabData) {
            this.setAccountNameDescription(organizationValue);
          }
        }
      },
      error: error => {
        this.accountname = organizationValue;
      }
    }
     );
  }

  

  setAccountNameDescription(organizationValue: string) {
    let vocabData = this.organizationVocabData.vocabularyItems?.find((item: any) => item?.code === organizationValue );
    this.accountname = vocabData?.description ?? organizationValue;
  }

  disableClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  searchClicked(orderId: any) {
    if (orderId) {
      this.resetOrderGridParamsStoredInService();
      this.sharedService.setOrderSearchTerm(orderId);
      this.router.navigate(['home']);
    }

    if (this.searchInput)
      this.searchInput.nativeElement.value = '';
  }

  subscribeBreadcrumbChange() {
   const subscription$ = this.sharedService.breadcrumbPath$.subscribe(path => {
      this.breadcrumbPath = path;
   });
    this.subscriptions.add(subscription$);
  }

  resetOrderGridParamsStoredInService() {
    this.sharedService.OrderGridParams.first = 0;
    this.sharedService.OrderGridParams.rowsPerPage = 10;
    this.sharedService.OrderGridParams.sortField = 'number';
    this.sharedService.OrderGridParams.sortOrder = -1;
    this.sharedService.OrderGridParams.updatedFilterValues = false;
    this.sharedService.OrderGridParams.accountName =  [];
    this.sharedService.OrderGridParams.createdBy =  [];
    this.sharedService.OrderGridParams.orderOwner = [];
    this.sharedService.OrderGridParams.orderType = [];
    this.sharedService.OrderGridParams.clientName = [];
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}